import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type {
  PolicyContentResponse,
  PolicySlugsResponse,
} from '@/features/policies/types/policy';

export async function fetchPolicySlugs() {
  const { data } = await httpClient.get(endpoints.policies.slugs);
  return data as PolicySlugsResponse;
}

export async function fetchPolicyContent(slug: string) {
  const { data } = await httpClient.get(endpoints.policies.content, {
    params: { slug },
  });
  return data as PolicyContentResponse;
}
